export class PaymentStatus{
    status: string;
    transactionId: string;
  
}


// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/paymentStatus.ts